export default function IconView({ color = '#1E3A8A', width = 36, height = 36, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='36' height='36' rx='18' fill={color} fillOpacity='0.1' />
      <path
        d='M25.9537 17.2042C26.207 17.5595 26.3337 17.7372 26.3337 18.0001C26.3337 18.263 26.207 18.4407 25.9537 18.7959C24.8152 20.3922 21.908 23.8334 18.0003 23.8334C14.0926 23.8334 11.1854 20.3922 10.047 18.7959C9.79367 18.4407 9.66699 18.263 9.66699 18.0001C9.66699 17.7372 9.79367 17.5595 10.047 17.2042C11.1854 15.6079 14.0926 12.1667 18.0003 12.1667C21.908 12.1667 24.8152 15.6079 25.9537 17.2042Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <path
        d='M20.5 18C20.5 16.6192 19.3807 15.5 18 15.5C16.6192 15.5 15.5 16.6192 15.5 18C15.5 19.3807 16.6192 20.5 18 20.5C19.3807 20.5 20.5 19.3807 20.5 18Z'
        stroke={color}
        strokeWidth='1.5'
      />
    </svg>
  );
}
